/**
 * Shared constants and value mappings for transaction summary lists
 */

/**
 * Payment method icon value mappings
 */
export const PAYMENT_METHOD_ICON_MAPPINGS = [
	{ value: 'Credit Card', iconName: 'credit-card' },
	{ value: 'Credit Card Reader', iconName: 'credit-card' },
	{ value: 'Check', iconName: 'money-check-dollar' },
	{ value: 'Cash', iconName: 'money-bill' },
	{ value: 'ACH', iconName: 'building' },
	{ value: 'Company Credit', iconName: 'building' },
] as const;

/**
 * Transaction status value mappings
 */
export const STATUS_VALUE_MAPPINGS = [
	{
		color: { bg: '#059669', text: '#ffffff' },
		value: 'succeeded',
		displayText: 'Succeeded',
	},
	{
		color: { bg: '#059669', text: '#ffffff' },
		value: 'completed',
		displayText: 'Completed',
	},
	{
		color: { bg: '#d97706', text: '#ffffff' },
		value: 'pending',
		displayText: 'Pending',
	},
	{
		color: { bg: '#d97706', text: '#ffffff' },
		value: 'processing',
		displayText: 'Processing',
	},
	{
		color: { bg: '#dc2626', text: '#ffffff' },
		value: 'failed',
		displayText: 'Failed',
	},
	{
		color: { bg: '#dc2626', text: '#ffffff' },
		value: 'error',
		displayText: 'Error',
	},
	{
		color: { bg: '#6b7280', text: '#ffffff' },
		value: 'cancelled',
		displayText: 'Cancelled',
	},
	{
		color: { bg: '#6b7280', text: '#ffffff' },
		value: 'voided',
		displayText: 'Voided',
	},
] as const;

/**
 * Required fields for all transaction lists
 */
export const TRANSACTION_REQUIRED_FIELDS = [
	'transaction_summary._id',
	'transaction_summary.clientAddress',
	'transaction_summary.clientCity',
	'transaction_summary.clientName',
	'transaction_summary.clientState',
	'transaction_summary.clientZipCode',
	'transaction_summary.m_payment_datetime',
	'transaction_summary.m_payment_netAmount',
	'transaction_summary.m_payment_origin',
	'transaction_summary.m_payment_payment_method_name',
	'transaction_summary.m_payment_payment_method_type',
	'transaction_summary.m_payment_status',
	'transaction_summary.m_sm_payment_amount',
	'transaction_summary.transactionType',
];

/**
 * Base filter rules for transaction lists
 */
export const BASE_FILTER_RULES = {
	transactionSalesRep: {
		defaultValue: [{ id: 'ME', label: 'Me' }],
		applyDefaultIf: {
			type: 'group',
			joiner: 'AND',
			negated: false,
			children: [
				{ type: 'rule', action: 'transactions:view:any', negated: true },
			],
		},
		lockedIf: {
			type: 'group',
			joiner: 'AND',
			negated: false,
			children: [
				{ type: 'rule', action: 'transactions:view:any', negated: true },
			],
		},
		hiddenIf: {
			type: 'group',
			joiner: 'AND',
			negated: false,
			children: [
				{ type: 'rule', action: 'transactions:view:any', negated: true },
			],
		},
	},
};
